const FormTextArea = {
  props: {
    css: { default: '' },
    rows: { default: 10 },
    value: { default: '' },
    limit: { default: 300 },
    placeholder: { default: '' },
  },
  data() {
    return {
      status: '',
      progress: 0,
      statuses: ['-danger', '-warning', '-success'],
    };
  },
  mounted() {
    this.calculate(this.value);
  },
  watch: {
    value: function (value) {
      this.calculate(value);
    },
  },
  methods: {
    calculate(value) {
      this.progress = value.length;
      let stage = Math.round(
        (this.statuses.length - 1) * Math.min(1, value.length / this.limit),
      );
      this.status = this.statuses[stage];
    },
  },
  template: `
      <div class="dmtk-textarea">
	      <textarea
	          :rows="rows"
	          class="uk-textarea"
	          :class="css"
	          :value="value"
	          :placeholder="placeholder"
	          @blur="$emit('blur', $event)"
	          @input="$emit('input', $event.target.value)"
	      ></textarea>
	      <progress
	          :max="limit"
	          :value="progress"
	          :class="status"
	          class="uk-progress"
	      ></progress>
      </div>
	`,
};
